import type { ReactNode } from 'react';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
  label: {
    display: 'block',
    color: token('color.text.accent.gray'),
    font: token('font.body.small'),
    marginBlockEnd: token('space.050', '4px'),
  },
});

interface LabelProps {
  children: ReactNode;
  htmlFor?: string;
}

const Label = ({ children, htmlFor }: LabelProps) => {
  if (htmlFor) {
    return (
      <label htmlFor={htmlFor} css={styles.label}>
        {children}
      </label>
    );
  }

  return <span css={styles.label}>{children}</span>;
};

export default Label;
